module.exports = __webpack_public_path__ + "static/media/loff-f.d8c9180d.mp3";